import React, { useRef } from "react";
import styles from "./upload.module.css";
import Label from "../Label";

const UploadBox = ({
  value,
  onChange,
  placeholder,
  name,
  label,
  inline = false,
  noBottomMargin = false,
  uploaded,
}) => {
  const fileRef = useRef(null);

  const handleFileClick = (e) => {
    e.preventDefault();
    fileRef.current.click();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: inline ? "row" : "column",
        marginBottom: noBottomMargin ? 0 : 20,
        cursor: "pointer",
      }}
    >
      <Label name={name} text={label} />
      <input
        ref={fileRef}
        id={name}
        accept=".pdf"
        style={{ display: "none" }}
        type="file"
        onChange={onChange}
        placeholder={placeholder}
      />
      <button className={styles.textBox} onClick={handleFileClick}>
        {value?.name
          ? `${uploaded ? "Uploaded" : "Selected"}: ${value.name}`
          : "Click to select file (only .pdf files)"}
      </button>
    </div>
  );
};

export default UploadBox;
